import React, { useEffect, useRef } from "react";
import parse from "html-react-parser";
import { RendererProps } from "./index";
import { DisplayContent } from "./renderer-styles";

const DisplayTextRenderer: React.FC<RendererProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const hasFired = useRef(false);

  useEffect(() => {
    if (!hasFired.current && !answer) {
      hasFired.current = true;
      onAnswer(null, true);
    }
  }, [answer, onAnswer]);

  const content = question.text || question.description;
  if (!content) return null;

  return (
    <>
      <DisplayContent>{parse(content)}</DisplayContent>
      {question.image_path && (
        <img
          src={question.image_path}
          alt=""
          style={{ maxWidth: "100%", marginTop: 16 }}
          onError={(e) => { (e.target as HTMLImageElement).style.display = "none"; }}
        />
      )}
    </>
  );
};

export default DisplayTextRenderer;
